//######## Referencable Type ########
export const referencableType_Hidden = 'hidden';
export const referencableType_Property = 'property';
export const referencableType_SingleValue = 'single-value';
export const referencableType_MultiValue = 'multi-value';
export const referencableTypes = [referencableType_Hidden, referencableType_Property, referencableType_SingleValue, referencableType_MultiValue,];
//# sourceMappingURL=types.js.map